import { useIntl } from 'lib/intl-utils'
import { FC } from 'lib/component-utils'
import { useUserContext } from 'lib/context'
import UseCases from 'components/landing/sellmonitor/blocks/UseCases'
import PrimaryFeatures from 'components/landing/sellmonitor/blocks/PrimaryFeatures'
import Pricing from 'components/landing/sellmonitor/blocks/Pricing'
import Testimonials from 'components/landing/sellmonitor/blocks/Testimonials'
import Faq from 'components/landing/sellmonitor/blocks/Faq'
import Cta from 'components/landing/sellmonitor/blocks/Cta'

const OtherHostIndexPage: FC = () => {
  const ctx = useUserContext()
  const { t } = useIntl()

  const isOtherHost = !['sellematics', 'sellmonitor', 'sellscreen'].includes(ctx.theme.hostType)

  if (!isOtherHost) {
    return null
  }

  return (
    <>
      <UseCases />
      <PrimaryFeatures />
      <Pricing />
      <Testimonials />
      <Faq className="bg-gray-50" />
      <Cta />
    </>
  )
}

export default OtherHostIndexPage
